import { render, staticRenderFns } from "./LogisticsTrack.vue?vue&type=template&id=0dce249c&scoped=true&"
import script from "./LogisticsTrack.vue?vue&type=script&lang=js&"
export * from "./LogisticsTrack.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsTrack.vue?vue&type=style&index=0&id=0dce249c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce249c",
  null
  
)

export default component.exports